import React, { Component } from "react";
import { observer } from "mobx-react";
import SettingDefaultLeftView from "./components/layouts/SettingDefaultLeftView";
import { fn_request_memo_set_type } from "../../function/FnBodyLayer";
import SettingDefaultRequestMemoKitchenView from "./sub/SettingDefaultRequestMemoKitchenView";
import SettingDefaultRequestMemoCustomerView from "./sub/SettingDefaultRequestMemoCustomerView";
import RequestMemoDeleteCheckView from "../main/body/layer/RequestMemoDeleteCheckView";
import { Link } from "react-router-dom";
import { kitchens_list, customer_list } from "http/SettingConn";

@observer
class SettingDefaultRequestMemoView extends Component {
  setTab = type => {
    const { rootStore } = this.props;
    rootStore.settingStore.setLayerRequestMemoTypeView(type);
  };

  render() {
    const { rootStore } = this.props;
    const settingStore = rootStore.settingStore;
    settingStore.setSettingUseMenu("request_memo");
    settingStore.setSettingView(false);

    return (
      <>
        <div className="article_setting">
          {/*왼쪽 메뉴 */}
          <SettingDefaultLeftView rootStore={rootStore} />

          <div className="section_content">
            <h3>요청메시지 관리</h3>
            {/* 탭추가 */}
            <div className="box_tab">
              <div
                className={"tab_txt " + (rootStore.layerStore.getLayerRequestMemoTypeView === "kitchen" ? " on" : "")}
                onClick={e => {
                  kitchens_list(rootStore);
                  fn_request_memo_set_type(rootStore, "kitchen");
                }}
              >
                주방요청 관리
              </div>
              <div
                className={"tab_txt " + (rootStore.layerStore.getLayerRequestMemoTypeView === "customer" ? " on" : "")}
                onClick={e => {
                  customer_list(rootStore);
                  fn_request_memo_set_type(rootStore, "customer");
                }}
              >
                고객요청 관리
              </div>
            </div>
            <div className="close">
              <Link to="/">
                <button type="button">
                  <span className="btn_order_history_close">닫기</span>
                </button>
              </Link>
            </div>
            {rootStore.layerStore.getLayerRequestMemoTypeView === "kitchen" ? (
              <SettingDefaultRequestMemoKitchenView rootStore={rootStore} />
            ) : (
              <SettingDefaultRequestMemoCustomerView rootStore={rootStore} />
            )}
          </div>
        </div>
        <RequestMemoDeleteCheckView rootStore={rootStore} /> {/*요청메시지 삭제 확인창*/}
      </>
    );
  }
}

export default SettingDefaultRequestMemoView;
